// Console Easter Egg for itj.dev
// Because developers deserve some fun! 🐸

export const showConsoleEasterEgg = () => {
  // Only show once per session
  if (sessionStorage.getItem('itj-console-egg-shown')) {
    return;
  }

  // ASCII Pepe the Frog - Simple text version!
  const pepe = `
⠀⠀⢀⣠⠤⠶⠖⠒⠒⠶⠦⠤⣄⠀⠀⠀⣀⡤⠤⠤⠤⠤⣄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⣴⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⣦⠞⠁⠀⠀⠀⠀⠀⠀⠉⠳⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⡾⠁⠀⠀⠀⠀⠀⠀⣀⣀⣀⣀⣀⣀⣘⡆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⣆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⢀⡴⠚⠉⠁⠀⠀⠀⠀⠈⠉⠙⠲⣄⣤⠤⠶⠒⠒⠲⠦⢤⣜⣧⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠳⡄⠀⠀⠀⠀⠀⠀⠀⠉⠳⢄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⣀⣀⣀⣀⣀⣀⣀⣀⣀⣀⣀⣀⠹⣆⠀⠀⠀⠀⠀⠀⣀⣀⣀⣹⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⣠⠞⣉⣡⠤⠴⠿⠗⠳⠶⣬⣙⠓⢦⡈⠙⢿⡀⠀⠀⢀⣼⣿⣿⣿⣿⣿⡿⣷⣤⡀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⣾⣡⠞⣁⣀⣀⣀⣠⣤⣤⣤⣄⣭⣷⣦⣽⣦⡀⢻⡄⠰⢟⣥⣾⣿⣏⣉⡙⠓⢦⣻⠃⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠉⠉⠙⠻⢤⣄⣼⣿⣽⣿⠟⠻⣿⠄⠀⠀⢻⡝⢿⡇⣠⣿⣿⣻⣿⠿⣿⡉⠓⠮⣿⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠙⢦⡈⠛⠿⣾⣿⣶⣾⡿⠀⠀⠀⢀⣳⣘⢻⣇⣿⣿⣽⣿⣶⣾⠃⣀⡴⣿⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠙⠲⠤⢄⣈⣉⣙⣓⣒⣒⣚⣉⣥⠟⠀⢯⣉⡉⠉⠉⠛⢉⣉⣡⡾⠁⠀⠀⠀⠀⠀⠀⠀
⠀⠀⣠⣤⡤⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢈⡿⠋⠀⠀⠀⠀⠈⠻⣍⠉⠀⠺⠿⠋⠙⣦⠀⠀⠀⠀⠀⠀⠀
⠀⣀⣥⣤⠴⠆⠀⠀⠀⠀⠀⠀⠀⣀⣠⠤⠖⠋⠀⠀⠀⠀⠀⠀⠀⠀⠈⠳⠀⠀⠀⠀⠀⢸⣧⠀⠀⠀⠀⠀⠀
⠸⢫⡟⠙⣛⠲⠤⣄⣀⣀⠀⠈⠋⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⠏⣨⠇⠀⠀⠀⠀⠀
⠀⠀⠻⢦⣈⠓⠶⠤⣄⣉⠉⠉⠛⠒⠲⠦⠤⠤⣤⣀⣀⣀⣀⣀⣀⣀⣀⣀⣀⣀⣠⠴⢋⡴⠋⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠉⠓⠦⣄⡀⠈⠙⠓⠒⠶⠶⠶⠶⠤⣤⣀⣀⣀⣀⣀⣉⣉⣉⣉⣉⣀⣠⠴⠋⣿⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠉⠓⠦⣄⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⡼⠁⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠉⠙⠛⠒⠒⠒⠒⠒⠤⠤⠤⠒⠒⠒⠒⠒⠒⠚⢉⡇⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⠴⠚⠛⠳⣤⠞⠁⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣤⠚⠁⠀⠀⠀⠀⠘⠲⣄⡀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣴⠋⠙⢷⡋⢙⡇⢀⡴⢒⡿⢶⣄⡴⠀⠙⠳⣄⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⢦⡀⠈⠛⢻⠛⢉⡴⣋⡴⠟⠁⠀⠀⠀⠀⠈⢧⡀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢻⡄⠀⠘⣶⢋⡞⠁⠀⠀⢀⡴⠂⠀⠀⠀⠀⠹⣄⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡇⠀⠀⠈⠻⢦⡀⠀⣰⠏⠀⠀⢀⡴⠃⢀⡄⠙⣆⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⡾⢷⡄⠀⠀⠀⠀⠉⠙⠯⠀⠀⡴⠋⠀⢠⠟⠀⠀⢹⡄
  `;

  const messages = [
    "🐸 Well, well, well... A fellow developer!",
    "",
    "You found the secret console easter egg! 🎉",
    "",
    "Since you're here poking around, you might appreciate that this site is built with:",
    "• React 19 + TypeScript + Vite",
    "• TailwindCSS + Framer Motion",
    "• Cloudflare Pages + Functions",
    "• Turnstile CAPTCHA + Resend Email API",
    "",
    "Fun fact: This Pepe took longer to ASCII-fy than the entire contact form! 😅",
    "",
    "Looking for a DevOps engineer? You're in the right place! 🚀",
    "Email: hello@itj.dev",
    "",
    "P.S. - If you're trying to hack this site... good luck! 😏",
    "It's protected by Cloudflare's enterprise security suite.",
    "",
    "Now go build something awesome! 💻✨"
  ];

  // Clear console first for dramatic effect
  console.clear();

  // Show ASCII art with green color
  console.log(`%c${pepe}`, 'color: #20b2aa; font-family: monospace;');

  // Show messages with different colors
  messages.forEach((message, index) => {
    setTimeout(() => {
      if (message === "") {
        console.log("");
      } else if (message.includes("🐸")) {
        console.log(`%c${message}`, 'color: #20b2aa; font-size: 16px; font-weight: bold;');
      } else if (message.includes("🎉") || message.includes("🚀") || message.includes("💻✨")) {
        console.log(`%c${message}`, 'color: #aa96da; font-size: 14px; font-weight: bold;');
      } else if (message.startsWith("•")) {
        console.log(`%c${message}`, 'color: #0078d4; font-size: 12px;');
      } else if (message.includes("Email:") || message.includes("P.S.")) {
        console.log(`%c${message}`, 'color: #326ce5; font-size: 12px; font-weight: bold;');
      } else {
        console.log(`%c${message}`, 'color: #90a4ae; font-size: 12px;');
      }
    }, index * 100);
  });

  // Mark as shown
  sessionStorage.setItem('itj-console-egg-shown', 'true');

  // Add some extra fun commands
  setTimeout(() => {
    console.log("");
    console.log("%cTry these fun commands:", 'color: #20b2aa; font-weight: bold;');
    console.log("%c• itj.pepe() - Show Pepe again", 'color: #aa96da;');
    console.log("%c• itj.stack() - Show tech stack", 'color: #aa96da;');
    console.log("%c• itj.hire() - Get contact info", 'color: #aa96da;');
    
    // Add global functions for fun
    (window as any).itj = {
      pepe: () => {
        console.log(`%c${pepe}`, 'color: #20b2aa; font-family: monospace;');
        console.log("%c🐸 Feels good man!", 'color: #20b2aa; font-size: 14px; font-weight: bold;');
      },
      stack: () => {
        console.log("%cTech Stack 🛠️", 'color: #20b2aa; font-size: 16px; font-weight: bold;');
        console.log("%cFrontend: React 19, TypeScript, TailwindCSS, Framer Motion", 'color: #0078d4;');
        console.log("%cBackend: Cloudflare Pages Functions, Resend API", 'color: #326ce5;');
        console.log("%cSecurity: Turnstile CAPTCHA, Anti-spam protection", 'color: #aa96da;');
        console.log("%cInfrastructure: Cloudflare Pages, CDN, DDoS protection", 'color: #20b2aa;');
      },
      hire: () => {
        console.log("%cLet's work together! 🤝", 'color: #20b2aa; font-size: 16px; font-weight: bold;');
        console.log("%cEmail: hello@itj.dev", 'color: #326ce5; font-weight: bold;');
        console.log("%cLinkedIn: https://linkedin.com/in/jakub-dudzinski", 'color: #0078d4;');
        console.log("%cGitHub: https://github.com/truskul", 'color: #aa96da;');
        console.log("%cSpecialties: DevOps, Cloud Architecture, Kubernetes, CI/CD", 'color: #90a4ae;');
      }
    };
  }, messages.length * 100 + 500);
};
